
import styled from "styled-components";
import Link from 'next/link';
import { Img } from '@/components/common/ui/images/Img';
import { theme } from '@/components/features/theme/theme';
import ReactHtmlParser from 'react-html-parser';
import CircleButton from '@/components/common/ui/buttons/CircleButton';
import reactHtmlParser from 'react-html-parser';

const BlogSingle = ({title, text, link, img, cat}) => {
	// Strip HTML tags for use in alt attribute
	const plainTitle = title ? title.replace(/<[^>]*>/g, '') : '';
	return (
		<StyledBlogSingle className="blog-single ">
			<Link className={'tag-wrapper'} prefetch={true} href={link || '/project/slug'} aria-label={plainTitle ? `View ${plainTitle}` : 'View product'}></Link>
			<div className="blog-single__inner">
				<h6>{title ? reactHtmlParser(title) : 'Pressure'}</h6>
				<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="20" cy="20" r="19.5" stroke="white" />
					<circle className={'cir-hover'} cx="20" cy="20" r="0" stroke={'#DD223F'} fill="#DD223F" />
					<path d="M14 19C13.4477 19 13 19.4477 13 20C13 20.5523 13.4477 21 14 21V19ZM26.7071 20.7071C27.0976 20.3166 27.0976 19.6834 26.7071 19.2929L20.3431 12.9289C19.9526 12.5384 19.3195 12.5384 18.9289 12.9289C18.5384 13.3195 18.5384 13.9526 18.9289 14.3431L24.5858 20L18.9289 25.6569C18.5384 26.0474 18.5384 26.6805 18.9289 27.0711C19.3195 27.4616 19.9526 27.4616 20.3431 27.0711L26.7071 20.7071ZM14 21H26V19H14V21Z" fill="white" />
				</svg>
				<Img src={img ? img : '/images/static/blur.jpg'} objectFit={'cover'} alt={plainTitle} layout={'fill'} />
			</div>
			<div className="blog-single__inner__content">
				<div className="blog-single__inner__content__top">
					<p>{text ? reactHtmlParser(text) : 'Advanced pressure measurement solutions ensure accuracy, reliability, and stability in demanding industrial environments. Designed to optimize performance and safety across various applications.'}</p>
				</div>

				<div className="cat">
					<p>
						<svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M4 8C6.20914 8 8 6.20914 8 4C8 1.79086 6.20914 0 4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8Z" fill="#DD223F" />
						</svg>
						<span>{cat ? reactHtmlParser(cat) : 'Measurement'}</span>
					</p>
				</div>
			</div>

		</StyledBlogSingle>
	);
};

const StyledBlogSingle = styled.div`
    //width: 100%;
    position: relative;
	border-radius: 5px;
	overflow: hidden;
	margin-bottom: 30px;
	

	
    .tag-wrapper {
        position: absolute;
        height: 100%;
        width: 100%;
        left: 0;
        top: 0;
        z-index: 3;
    }

    .blog-single__inner {
        padding-top: calc(185 / 370 * 100%);
        position: relative;
        overflow: hidden;
		&:after{
			position: absolute;
			inset: 0;
			width: 100%;
			height: 100%;
			background-color: rgba(0, 0, 0, 0.35);
			content: '';
		}
		img{
			transform: scale(1.01);
            transition: ${theme.transition};
			
		}
		svg{
			position: absolute;
			top: 20px;
			right: 20px;
            z-index: 2;
			.cir-hover{
				transition: ${theme.transition};
			}
		}
		h6{
			position: absolute;
			left: 30px;
			bottom: 30px;
            font-weight: 700;
            font-size: 1.5rem;       /* 24px */
            line-height: 1.75rem;    /* 28px */
            letter-spacing: 0;
			color: #FFFFFF;
			z-index: 2;
        }


    }

    .blog-single__inner__content{
		border-bottom: 1px solid #152637;
		border-left: 1px solid #152637;
		border-right: 1px solid #152637;
		border-bottom-right-radius: 5px;
		border-bottom-left-radius: 5px;
		padding: 30px;
        transition: ${theme.transition};
		
		h6{
            color: #272522;
            font-size: 40px;
            font-style: normal;
            font-weight: 600;
            line-height: 100%; /* 40px */
            letter-spacing: -2px;
			margin-bottom: 16px;
			transition: ${theme.transition};
		}
		p{
            font-weight: 400;
            font-size: 1rem;         /* 16px */
            line-height: 1.5rem;     /* 24px */
            letter-spacing: 0;
            transition: ${theme.transition};
            display: -webkit-box;
            -webkit-line-clamp: 4;      /* Limit to 4 lines */
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
        }
	}
	
	.cat{
		margin-top: 60px;
		p{
			align-items: center;
			display: flex;
			gap: 10px;
            font-weight: 400;
            font-size: 0.8125rem;     /* 13px */
            line-height: 1rem;         /* 16px */
            letter-spacing: 0;
		}
	}


	&:hover{
		.blog-single__inner{
            img{
                transform: scale(1.1);
            }
			svg{
				.cir-hover{
					r:19.5px;
				}
			}	
		}
		.blog-single__inner__content{
			border-color: #DD223F;
			p{
				color: #DD223F;
			}
		}
	}



`;
export default BlogSingle;
